import { render, staticRenderFns } from "./SfLink.vue?vue&type=template&id=2e13fdd7"
import script from "./SfLink.vue?vue&type=script&lang=js"
export * from "./SfLink.vue?vue&type=script&lang=js"
import style0 from "./SfLink.vue?vue&type=style&index=0&id=2e13fdd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports